import ActionTypes from "../../../constants/ActionTypes";
import { IProduct } from "../../../entities/product/types";

export function setPreBasketProducts(products: IProduct[]) {
  return {
    type: ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCTS,
    payload: {
      products,
    }
  };
}

export function setPreBasketProductData(productData: any) {
  return {
    type: ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCT_DATA,
    payload: {
      productData,
    }
  };
}

export function setEditMode(editMode: boolean) {
  return {
    type: ActionTypes.PRODUCT.SET_EDIT_MODE,
    payload: editMode
  };
}

export function removePreBasketProduct(productId: number) {
  return {
    type: ActionTypes.PRODUCT.REMOVE_PRE_BASKET_PRODUCT,
    payload: {
      productId,
    }
  };
}

export function setPreBasketProductInSessionStorage() {
  return {
    type: ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCT_IN_SESSION_STORAGE,
  };
}

export function setEditModeInSessionStorage(editMode: boolean) {
  return {
    type: ActionTypes.PRODUCT.SET_EDIT_MODE_IN_SESSION_STORAGE,
    payload: {
      editMode,
    }
  };
}

export function clearPreBasketAction() {
  return {
    type: ActionTypes.PRODUCT.CLEAR_PRE_BASKET,
  };
}

export function getPreBasket() {
  return {
    type: ActionTypes.PRODUCT.GET_PRE_BASKET,
  };
}

